import { useEffect, useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Box } from '@mui/material';

// Utility to get cookie by name
const getCookie = (name) => {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
};

// Utility to set cookie with expiration in hours
const setCookie = (name, value, hours) => {
    const expires = new Date();
    expires.setTime(expires.getTime() + hours * 60 * 60 * 1000);
    document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
};

const PopupNotice = () => {
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const hasSeenPopup = getCookie('hidePopup');
        if (!hasSeenPopup) {
            setOpen(true);
        }
    }, []);

    const handleClose = () => {
        setCookie('hidePopup', 'true', 24); // 24 hours
        setOpen(false);
    };

    const handleRedirect = () => {
        window.location.href = 'https://paytree-cloud.com'; // update as needed
    };

    const handleDialogClose = (event, reason) => {
        if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
            return; // ignore outside click or Esc
        }
        handleClose();
    };

    return (
        <Dialog open={open} onClose={handleDialogClose} disableEscapeKeyDown>
            <DialogTitle>Migratie naar Paytree-Cloud</DialogTitle>
            <DialogContent>
                <Typography>
                    Je bevindt je op het oude Paytree-platform. We zijn overgestapt naar Paytree-Cloud: ons vernieuwde en verbeterde
                    dashboard. Dit platform blijft voorlopig nog beschikbaar om bestaande gegevens in te zien of laatste
                    {/* eslint-disable-next-line react/no-unescaped-entities */}
                    handelingen af te ronden. Klik op "Naar Paytree-Cloud" om direct verder te gaan naar het nieuwe platform.
                </Typography>
            </DialogContent>
            <DialogActions>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: { xs: 'column', sm: 'row' },
                        gap: 1,
                        width: '100%'
                    }}
                >
                    <Button onClick={handleClose} variant="contained" color="secondary" fullWidth>
                        Toch doorgaan
                    </Button>
                    <Button onClick={handleRedirect} variant="contained" color="primary" fullWidth>
                        Naar Paytree-Cloud
                    </Button>
                </Box>
            </DialogActions>
        </Dialog>
    );
};

export default PopupNotice;
